import type { Size } from '../types'

export function GChatIcon({ className, size }: { className?: string; size: Size }) {
  return (
    <svg
      className={className}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_1401_16845)">
        <path
          d="M4.352 10.7881V4.28809H1.512C0.676 4.28809 0 4.96809 0 5.80409V19.2401C0 19.9161 0.816 20.2521 1.292 19.7761L4.416 16.6521H13.312C14.148 16.6521 14.824 15.9761 14.824 15.1401V12.3001H5.868C5.032 12.3001 4.352 11.6241 4.352 10.7881Z"
          fill="#00AC47"
        />
        <path
          d="M17.664 0H5.86796C5.03196 0 4.35596 0.676 4.35596 1.512V4.288H13.312C14.148 4.288 14.824 4.964 14.824 5.8V12.296H17.664C18.5 12.296 19.176 11.62 19.176 10.784V1.512C19.176 0.676 18.5 0 17.664 0Z"
          fill="#5BB974"
        />
        <path
          d="M13.312 4.28809H4.35205V10.7841C4.35205 11.6201 5.02805 12.2961 5.86405 12.2961H14.8201V5.80409C14.8241 4.96809 14.148 4.28809 13.312 4.28809Z"
          fill="#00832D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1401_16845">
          <rect
            width="19.176"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
